import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchReposSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS: TypedDocumentNode<
  {
    searchReposSuggestions: SearchSuggestionsOutput;
  },
  QuerySearchReposSuggestionsArgs
> = gql`
  query SearchSpaceliftVcsReposSuggestions($input: SearchSuggestionsInput!) {
    searchReposSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

export const SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT = gql`
  fragment SearchSpaceliftVcsReposSuggestionsFilteredCountFragment on Query {
    searchReposSuggestions(input: $input) {
      filteredCount
    }
  }
`;
